<template>
    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 space-preview">
        <div class="space-preview-container">
            <table class="table">
                <tr>
                    <th>Building</th>
                    <td v-text="space.building"></td>
                </tr>
                <tr>
                    <th>Floor</th>
                    <td v-text="space.floor"></td>
                </tr>
                <tr>
                    <th>Name</th>
                    <td v-text="space.name"></td>
                </tr>
                <tr>
                    <th>Status</th>
                    <td>
                        <div class="dot-status-list">
                            <test-result-icon v-for="(form, index) in space.forms"
                                              :key="form.test.id"
                                              :form="form">
                            </test-result-icon>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <a class="btn btn-block btn-default btn-sm" :href="`/projects/${project.slug}/spaces/${space.slug}`">Details</a>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            space: {
                type: Object,
                required: true,
            },
            project:{
                type: Object,
                required: true,
            }
        },
    }
</script>
